import React from 'react'
import subscriptionApi from '../../api/subscription'
import { useQuery } from '@tanstack/react-query'
import SubscriptionPricingSection from './SubscriptionPricingSection'
import RocketLauncherLoader from '../../components/common/RocketLauncherLoader'

const SubscriptionPricingPage = ({onNavigate}) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
        queryKey: ['subscriptions'],
        queryFn: async () => {
            const res = await subscriptionApi.getSubcriptionPlans()
            return res.data
        }
    })

    if (isLoading) return <RocketLauncherLoader />

    if (isError) return <div>Failed to load pricing cards...{error.message}</div>;

    return (
        <SubscriptionPricingSection onSubscribe={() => onNavigate('/dashboard')} plans={data} />
    );
}

export default SubscriptionPricingPage